import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'miq-edp-edit-failed',
  templateUrl: './edp-edit-failed.component.html',
  styleUrls: ['./edp-edit-failed.component.scss'],
  standalone: false,
})
export class EdpEditFailedComponent {
  message: string;

  private messageOne: string;
  private messageTwo: string;
  private clipboardMessage: string;

  constructor(
    public dialogRef: MatDialogRef<EdpEditFailedComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: { isClipboard: boolean },
    public translationService: L10nTranslationService
  ) {
    this.messageOne = this.translationService.translate('shared.messageOne');
    this.messageTwo = this.translationService.translate('shared.messageTwo');
    this.clipboardMessage = this.translationService.translate('shared.clipboardMessage');
    this.message = this.composeMessage();
  }

  composeMessage() {
    return `${this.messageOne} ${!!this.data && this.data.isClipboard ? this.clipboardMessage + ' ' : ''}${
      this.messageTwo
    }`;
  }

  onClose(retry: boolean) {
    this.dialogRef.close(retry);
  }
}
